import React from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import SplThaliPm from '../SplThaliPm';
import SplThaliAm from '../SplThaliAm';

const GroupPackage = () => {
  return (
    <section className="sp-cnt-blk corporate">
      <Container>
        <div className='sp-cnt-in text-center'>
          <div className='sp-cnt-in2'>
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
          <div className='hdg'><figure><Image src={`${process.env.PUBLIC_URL}/images/group-package-hdg.png`} fluid /></figure></div>
          <div className='session-wrap'>
            <div className="hdg2"><div className="spl-thalli-hdg"><h3>Special Thali <span>04:00 PM to 10:00 PM</span></h3></div></div>
            <SplThaliPm /></div>
          <div className='session-wrap eve'>
            <div className="hdg2"><div className="spl-thalli-hdg"><h3>Special Thali <span>10:00 AM to 02:30 PM</span></h3></div></div>
           <SplThaliAm /></div>        
            <Row>
            <div className="contact-wrap">
                <div className='whatsapp-blk'>
                    <p>For more updates please</p>
                    <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
                </div>
             </div>
            </Row>
          </div>
        </div>
      </Container>
    </section>      
  )
}

export default GroupPackage